import { useState } from 'react';
import { useSelector } from 'react-redux';
import { createVehiculo } from '../../helpers/api_helper';

const useCreateVehiculo = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const createVehiculoHook = async (datosVehiculo) => {
        setLoading(true);
        setError(null);
        try {
            const params = { tenantId };
            const response = await createVehiculo(
                { vehicleData: datosVehiculo, tenantId, empresa, departamento, usuario: userInfo?.name },
                params
            );
            if (response.CLACLI) {
                const result = response;
                return { success: true, data: result };
            } else {
                throw new Error(response.message || 'Error al guardar el vehículo');
            }
        } catch (err) {
            const errorMessage = `Failed to create vehiculo: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createVehiculo: createVehiculoHook, loading, error };
};

export default useCreateVehiculo;
